module.exports = __webpack_public_path__ + "42f639c7603b3479088532d9b3fca06b.svg";